module.exports = __webpack_public_path__ + "static/media/github.4f89cf8c.svg";